module.exports = __webpack_public_path__ + "static/media/sort-amount-down.eab2f93a.svg";